
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/[portfolioSlug]",
      function () {
        return require("private-next-pages/portfolio/[portfolioSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio/[portfolioSlug]"])
      });
    }
  